import type { Status } from "ui/StatusLabel/types/status";

export const isStatusVisible = (status: Status): boolean => {
  return status !== "onSale";
};
